import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { Router } from '@angular/router';
import { AppModalService } from '../../../shared/services/app-modal.service';
import { DOCUMENT } from '@angular/common';
import { ClickhouseService } from '../../../shared/services/clickhouse.service';
import { filter } from 'rxjs/operators';
import { NavigationService } from '../../../components/layouts/navigation/navigation.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  @ViewChild('eye') eye!: ElementRef;
  @ViewChild('eyeClose') eyeClose!: ElementRef;
  @ViewChild('eyeOpen') eyeOpen!: ElementRef;
  @ViewChild('passInput') passInput!: ElementRef;

  loginForm: FormGroup;

  messageText = '';
  messageType = '';

  get moreLink() {
    return 'https://improvemath.me/?source=learn_more';
  }

  constructor(
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private router: Router,
    private myModal: AppModalService,
    private navigationService: NavigationService,
    @Inject(DOCUMENT) public document: any,
    private clickhouseService: ClickhouseService,
  ) {
    this.loginForm = new FormGroup({
      emailControl: new FormControl('', [
        Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,5}$/),
      ]),
      passControl: new FormControl(''),
    });
  }

  login() {
    if (!this.loginForm.value.emailControl || !this.loginForm.value.passControl) {
      this.myModal.open({
        title: 'Fill all fields',
        canClose: true,
      });
    } else {
      if (!this.loginForm.controls.emailControl.errors?.pattern) {
        this.spinner.show();
        this.authService
          .login(this.loginForm.value.emailControl, this.loginForm.value.passControl)
          .subscribe((response: any) => {
            if (response.status === 'error') {
              this.messageType = 'danger';
              this.messageText = response.data.messages || 'Email or Password is not correct!';
              this.spinner.hide();
            } else {
              this.clickhouseService.storeEvent('login_form').subscribe(() => {});
              this.router.navigate(['/']);

              this.navigationService.instanceObservable
                .pipe(filter((instance) => !!instance))
                .subscribe(() => {
                  this.navigationService.openDownloadAppModal();
                });
            }
          });
      }
    }
  }

  onPassInput() {
    if (this.loginForm.value.passControl) {
      this.eye.nativeElement.classList.remove('d-none');
    } else {
      this.eye.nativeElement.classList.add('d-none');
    }
  }

  showPass() {
    if (this.eyeOpen.nativeElement.classList.contains('d-none')) {
      this.eyeClose.nativeElement.classList.add('d-none');
      this.eyeOpen.nativeElement.classList.remove('d-none');
      this.passInput.nativeElement.type = 'text';
    } else {
      this.eyeClose.nativeElement.classList.remove('d-none');
      this.eyeOpen.nativeElement.classList.add('d-none');
      this.passInput.nativeElement.type = 'password';
    }
  }

  closeAlert() {
    this.messageType = '';
    this.messageText = '';
  }

  toLowerCase() {
    this.loginForm
      .get('emailControl')
      ?.setValue(this.loginForm.controls.emailControl.value.toLowerCase());
  }
}
